var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlan = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M21 20h2v2H1v-2h2V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zm-2 0V4H5v16zM8 16h3v2H8zm5 0h3v2h-3z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11 16v2h2v-2zM12 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8m-1.4-3.2v.8h1v.8h.8v-.8h.4a1 1 0 0 0 0-2h-1.6a.2.2 0 0 1 0-.4h2.2v-.8h-1v-.8h-.8v.8h-.4a1 1 0 1 0 0 2h1.6a.2.2 0 0 1 0 .4z"
})));
export { SvgPlan as ReactComponent };
export default __webpack_public_path__ + "assets/images/plan.svg";